import { Text } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { iconSize } from '../../../../../constants/icon.constants';
import ctaTypes from '../../../../../enums/CTA.enums';
import { googleClickCtaEvent } from '../../../../../utils/analytics';
import { targetLinkdsk } from '../../../../../utils/targetDskLink';
import CTA from '../../../../@shared/cta';
import Icon from '../../../../@shared/icon';
import InputBox from './inputBox';

const TableHeader = (props) => {
  const { t } = useTranslation();
  const {
    model,
    isEE,
    isDesktop,
    toggleAllRows,
    expandedRows,
    hideArrowButton,
    moveGridLeft,
    moveGridRight,
    setSearchTerm,
    searchTerm,
    printStart,
  } = props;
  return (
    <div className="model-details-specification-table-header">
      <div className="model-details-specification-table-header__wrapper">
        {model.eyebrow && (
          <Text field={model.eyebrow} tag="p" className="model-details-specification-table-header__eyebrow" editable={true} />
        )}
        {model.heading && (
          <Text field={model.heading} tag={model.headingTag} className="model-details-specification-table-header__title" editable={true} />
        )}
        {(isEE || (model?.link?.value?.href && model?.link?.value?.text)) && (
          <div className="model-details-specification-table-header__title-link-wrapper">
            <CTA
              type={ctaTypes.secondaryRed}
              field={model.link}
              target={targetLinkdsk(model?.link, isDesktop)}
              extraClassName="model-details-specification-table-header__link-cta"
              onClick={() => googleClickCtaEvent('Link', model?.link?.value?.text, model?.heading?.value ?? model.eyebrow?.value)}
            />
            <div className="model-details-specification-table-header__links-wrapper model-details-specification-table-header__flex">
              {isDesktop && !model.disableExcel && (
                // special case to not use RoutableNotEditableLink
                // ignored to allow download
                <a
                  className="model-details-specification-table-header__link--export"
                  href={model.convertToExcelLink}
                >
                  <span className="model-details-specification-table-header__link--export__text">{t('cnhi-excelExport')}</span>
                  <Icon
                    iconField={model.iconsList[1]}
                    color="primary"
                    size={iconSize.sm}
                    extraClassName="model-details-specification-table-header__link__icon"
                  />
                </a>
              )}
              {isDesktop && !model.disablePrint && (
                <span
                  className="model-details-specification-table-header__link--print table-header__link--print"
                  onClick={() => {
                    printStart();
                  }}
                >
                  <span className="model-details-specification-table-header__link--print__text">{t('cnhi-print')}</span>
                  <Icon
                    color="primary"
                    iconField={model?.iconsList[0]}
                    size={iconSize.sm}
                    extraClassName="model-details-specification-table-header__link--print__icon"
                  />
                </span>
              )}
            </div>
          </div>
        )}
        <div className="model-details-specification-table-header__last-row table-header__link__last-row model-details-specification-table-header__flex">
          <div>
            {!model.disableExpand && (
              <button className="model-details-specification-table-header__link--button" onClick={toggleAllRows}>
                {expandedRows.length === model.groupItemsIndexes.length ? t('cnhi-collapseAll') : t('cnhi-expandAll')}
                <Icon
                  iconName={expandedRows.length === model.groupItemsIndexes.length ? 'action-minus' : 'action-plus'}
                  size={iconSize.dsk}
                  color="primary"
                  extraClassName="table-expand-icon"
                />
              </button>
            )}
            {isDesktop && !model.disableSearch && <InputBox searchTerm={searchTerm} setSearchTerm={setSearchTerm} t={t} />}
          </div>
          {!isDesktop && !model.disableExcel && (
                // special case to not use RoutableNotEditableLink
                // ignored to allow download
                <a
                  className="model-details-specification-table-header__link--export table-header__link--export"
                  href={model.convertToExcelLink}
                >
                  <Icon
                    iconField={model.iconsList[1]}
                    color="primary"
                    size={iconSize.mbl}
                    extraClassName="model-details-specification-table-header__link__icon"
                  />
                </a>
              )}
          {!isDesktop && !model.disablePrint && (
            <span className="model-details-specification-table-header__link--print table-header__link--print">
              <span onClick={printStart}>
                <Icon
                  color="primary"
                  iconField={model?.iconsList[0]}
                  size={iconSize.mbl}
                  extraClassName="model-details-specification-table-header__link--print__icon"
                />
              </span>
            </span>
          )}
          {!hideArrowButton && (
            <div className="model-details-specification-table-header__arrow-wrapper">
              <div className="model-details-specification-table-header__arrow" onClick={moveGridLeft}>
                <Icon
                  iconName="arrow-chevron-left"
                  size={iconSize.xlg}
                  color="primary"
                  extraClassName="model-details-specification-table-header__arrow--left"
                />
              </div>
              <div className="model-details-specification-table-header__arrow" onClick={moveGridRight}>
                <Icon
                  iconName="arrow-chevron-right"
                  size={iconSize.xlg}
                  color="primary"
                  extraClassName="model-details-specification-table-header__arrow--right"
                />
              </div>
            </div>
          )}
        </div>
        {!isDesktop && !model.disableSearch && <InputBox searchTerm={searchTerm} setSearchTerm={setSearchTerm} t={t} />}
      </div>
    </div>
  );
};

export default TableHeader;
